export default __webpack_public_path__ + "static/media/survey1.b89b5455.svg";